// TODO: this should be a label / we need to refactor this with accessibility ARIA in mind
const FieldTitle = ({ title = '', required = false }) => (
    <h6 className="my-1" title={`${required ? 'Required Field' : ''}`}>
        {title}
        {required && <span className="text-orange">&nbsp;*</span>}
    </h6>
);

export default FieldTitle;
